import React from 'react'
import styles from './ZoomButton.module.scss'

export const mapZoomTextIn = window?.drupalSettings?.widgets?.mapZoom?.textZoomIn || ''

const ZoomButtonRedesign = (props) => (
  <button className={styles.zoomButtonRedesign} {...props}>
    <i className="icon-ZOOM2" />
    <span>
      {mapZoomTextIn}
    </span>
  </button>
)

export default ZoomButtonRedesign
